var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "27", height: "11", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.5 11l.6-.6-4.4-4.5h15.2L21 10l.6-.6-3.4-3.5h4.1l4.1 4.1.6-.6-3.7-3.8v-.2L27 1.6l-.6-.6-4.1 4.1h-4.1l3.4-3.5L21 1l-4.1 4.1H1.7L6.1.6 5.5 0 0 5.5z", fill: "currentColor", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ./src/assets/icons/Arrow.svg